<sim-base-chip-input
	[formState]="roomGroupFc"
	[label]="label"
	[placeholder]="placeholder"
	[autoCompleteValues]="autoCompleteData"
	[isMultiSelect]="canSelectMultipleRoomGroups"
	(searchFieldChanged)="reloadAutoCompleteData($event)"
	(optionSelected)="optionSelected.emit($event)"
>
	<ng-container labelSuffix>
		<ng-content select="[labelSuffix]" />
	</ng-container>
</sim-base-chip-input>
